import { useLanguage } from "@/contexts/LanguageContext";
import oneIcon from "@/assets/Icons/Number_1.png";
import twoIcon from "@/assets/Icons/Number_2.png";
import threeIcon from "@/assets/Icons/Number_3.png";


const HowItWorks = () => {
  const { language } = useLanguage();

  const content = {
    is: {
      title: "Hvernig virkar þetta?",
      steps: [
        {
          number: oneIcon,
          heading: "Bókaðu fund",
          description: "Hafðu samband og við finnum hentugan tíma til að hittast og ræða málin. Á fundinum förum við yfir þarfir þínar, markmið og þær áskoranir sem þú vilt fá aðstoð við. Saman greinum við stöðuna og mótum næstu skref sem henta þér og þínu fyrirtæki."
        },
        {
          number: twoIcon,
          heading: "Skoðum lausnir",
          description: "Í framhaldinu skoðum við hvaða lausnir henta þér best og kortleggjum mismunandi valkosti. Við útfærum hugmyndirnar með skýrum hætti, sýnum mögulegar nálganir og gerum grein fyrir því hvernig hver lausn getur stutt markmið þín á skilvirkan og öruggan hátt."
        },
        {
          number: threeIcon,
          heading: "Innleiðing og viðhald",
          description: "Að lokinni ákvörðun hefjum við innleiðingu lausnarinnar og sérsníðum hana að þínum kerfum og verklagi. Við framkvæmum ítarlegar prófanir, tryggjum hiklausa innleiðingu og bjóðum áframhaldandi stuðning og viðhald svo kerfin þín haldi áfram að virka á skilvirkan hátt. Við erum alltaf til staðar ef þörf er á breytingum eða spurningum."
        }
      ]
    },
    en: {
      title: "How It Works",
      steps: [
        {
            number: oneIcon,
            heading: "Book a Meeting",
            description: "Choose a convenient time to meet and discuss your needs. During the meeting, we review your goals, requirements, and any challenges you want help with. Together, we assess the situation and outline the next steps that suit you and your business."
        },
        {
            number: twoIcon,
            heading: "Explore Solutions",
            description: "Next, we look into which solutions best fit your needs and map out the different options. We present the ideas clearly, show possible approaches, and explain how each solution can support your goals effectively and reliably."
        },
        {
            number: threeIcon,
            heading: "Implementation and Maintenance",
            description: "Once a decision is made, we begin implementing the solution and tailor it to your systems and workflow. We carry out thorough testing, ensure a smooth rollout, and provide ongoing support and maintenance so your systems continue to run efficiently. We’re always here if you need adjustments or have questions."
        }
      ]
    }
  };

  const t = content[language];

  return (
    <section className="py-16 md:py-24 bg-background">
      <div className="container px-6 md:px-8">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 md:mb-16">
          {t.title}
        </h2>

        {/* Desktop Layout */}
        <div className="hidden md:block relative">
          {/* Connecting Line */}
          <div className="absolute top-12 left-0 right-0 h-0.5 bg-border" 
               style={{ left: '10%', right: '10%' }} 
          />

          <div className="grid grid-cols-3 gap-8 relative">
            {t.steps.map((step, index) => (
              <div key={index} className="relative">
                {/* Number Circle */}
                <div className="flex justify-center mb-6">
                    <img
                      src={step.number}
                      alt={`Step ${index + 1}`}
                      className="w-24 h-24 object-contain"
                    />
                </div>

                {/* Content */}
                <div className="text-center">
                  <h3 className="text-xl font-semibold mb-3">
                    {step.heading}
                  </h3>
                  <p className="text-muted-foreground leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Mobile Layout */}
        <div className="md:hidden space-y-8">
          {t.steps.map((step, index) => (
            <div key={index} className="relative">
              {/* Number Circle */}
              <div className="flex items-start gap-4">
                  <img
                    src={step.number}
                    alt={`Step ${index + 1}`}
                    className="w-16 h-16 object-contain"
                  />

                {/* Content */}
                <div className="flex-1 pt-2">
                  <h3 className="text-lg font-semibold mb-2">
                    {step.heading}
                  </h3>
                  <p className="text-muted-foreground text-sm leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>

              {/* Divider (not on last item) */}
              {index < t.steps.length - 1 && (
                <div className="mt-8 border-b border-border" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;